export default "__VITE_ASSET__C9Eaac51__"